var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBoxGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.292 4.45949C23.5008 4.54283 23.6799 4.68683 23.8061 4.87292C23.9323 5.05901 23.9998 5.27864 24 5.50349V18.4965C23.9998 18.7213 23.9323 18.941 23.8061 19.1271C23.6799 19.3131 23.5008 19.4571 23.292 19.5405L12.417 23.8905C12.1488 23.9977 11.8497 23.9977 11.5815 23.8905L0.7065 19.5405C0.497953 19.4569 0.319208 19.3128 0.193291 19.1267C0.0673734 18.9407 5.22899e-05 18.7212 0 18.4965L0 5.50349C5.22899e-05 5.27882 0.0673734 5.05931 0.193291 4.87324C0.319208 4.68717 0.497953 4.54306 0.7065 4.45949L11.1645 0.275986L11.1705 0.274486L11.5815 0.109486C11.8501 0.00183483 12.1499 0.00183483 12.4185 0.109486L12.8295 0.274486L12.8355 0.275986L23.292 4.45949ZM21.231 5.24999L12 8.94299L2.769 5.24999L1.5 5.75849V6.35849L11.25 10.2585V22.1415L12 22.4415L12.75 22.1415V10.26L22.5 6.35999V5.75999L21.231 5.25149V5.24999Z",
    fill: "#28A8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxGray);
export default __webpack_public_path__ + "static/media/ic_box_gray.5da3d048bc256d6048ca8d4faeb64b42.svg";
export { ForwardRef as ReactComponent };